export enum SkillTypeEnum {
  SOFT_SKILLS_UNIFIED = 3,
  HARD_SKILLS_UNIFIED
}
